import { application } from "./application"

import TurtleController from "./turtle_controller"
application.register("turtle", TurtleController)

import EditorController from "./editor_controller"
application.register("editor", EditorController)

import LangController from "./lang_controller"
application.register("lang", LangController)

import SlidesController from "./slides_controller"
application.register("slides", SlidesController)
